/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GlobalSettingsPost$Params {
  emergencytoken?: string | null;
}

export function globalSettingsPost(http: HttpClient, rootUrl: string, params?: GlobalSettingsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, globalSettingsPost.PATH, 'post');
  if (params) {
    rb.query('emergencytoken', params.emergencytoken, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

globalSettingsPost.PATH = '/api/GlobalSettings/emergencytoken/create';
